// extracted by mini-css-extract-plugin
export default {"selectWrapper":"OptionalRequirementsSelect_selectWrapper__Yf+F6"};